<template>
  <mu-slide-right-transition>
    <router-view id="routerView"/>
  </mu-slide-right-transition>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
    data() {
      return{

      }
    },
    created() {
      // 微信config
      this.requestWxStr();
    },
    methods: {
      async requestWxStr() {
        let url = window.location.href.split("#")[0];
        this.$get("/wx/signature",{url: url})
            .then(res => {
              if(res) {
                // 配置微信api
                wx.config({
                  debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                  appId: process.env.VUE_APP_AppID, // 必填，公众号的唯一标识
                  timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                  nonceStr: res.data.noncestr,   // 必填，生成签名的随机串
                  signature: res.data.signature, // 必填，签名，见附录1
                  jsApiList: ["scanQRCode",
                    "showAllNonBaseMenuItem",
                    "hideAllNonBaseMenuItem",
                    "hideMenuItems",
                    "updateAppMessageShareData",
                    "updateTimelineShareData",
                    "chooseWXPay",
                    "hideOptionMenu"]
                });
              }
            })
      },
    }
}
</script>

<style>
/* muse-ui 图标 */
/*@import '//fonts.useso.com/css?family=Roboto:300,400,500,700,400italic';*/
@import 'https://cdn.bootcss.com/material-design-icons/3.0.1/iconfont/material-icons.css';
</style>
